import React from 'react';
import Icon from '../../../components/AppIcon';

const OperationalOverview = ({ data }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-red-600 bg-red-50 border-red-200';
      case 'medium':
        return 'text-yellow-600 bg-yellow-50 border-yellow-200';
      case 'low':
        return 'text-green-600 bg-green-50 border-green-200';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Operational Overview</h2>
        <p className="text-sm text-gray-600">Equipment, staff, and facility management</p>
      </div>

      {/* Status Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        {/* Equipment Status */}
        <div className="border border-gray-200 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-4">
            <Icon name="Wrench" className="w-5 h-5 text-gray-700" />
            <h3 className="text-sm font-semibold text-gray-900">Equipment Status</h3>
          </div>
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Operational</span>
              <span className="text-lg font-bold text-green-600">{data?.equipmentStatus?.operational}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Maintenance</span>
              <span className="text-lg font-bold text-yellow-600">{data?.equipmentStatus?.maintenance}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Out of Service</span>
              <span className="text-lg font-bold text-red-600">{data?.equipmentStatus?.outOfService}</span>
            </div>
          </div>
        </div>

        {/* Staff Schedule */}
        <div className="border border-gray-200 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-4">
            <Icon name="Users" className="w-5 h-5 text-gray-700" />
            <h3 className="text-sm font-semibold text-gray-900">Staff Schedule</h3>
          </div>
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">On Duty</span>
              <span className="text-lg font-bold text-green-600">{data?.staffSchedule?.onDuty}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Scheduled</span>
              <span className="text-lg font-bold text-blue-600">{data?.staffSchedule?.scheduled}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Conflicts</span>
              <span className="text-lg font-bold text-red-600">{data?.staffSchedule?.conflicts}</span>
            </div>
          </div>
        </div>

        {/* Facility Capacity */}
        <div className="border border-gray-200 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-4">
            <Icon name="Building" className="w-5 h-5 text-gray-700" />
            <h3 className="text-sm font-semibold text-gray-900">Facility Capacity</h3>
          </div>
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Current</span>
              <span className="text-lg font-bold text-blue-600">{data?.facilityCapacity?.current}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Maximum</span>
              <span className="text-lg font-bold text-gray-900">{data?.facilityCapacity?.maximum}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Utilization</span>
              <span className="text-lg font-bold text-primary-600">{data?.facilityCapacity?.utilization}%</span>
            </div>
          </div>
        </div>
      </div>

      {/* Upcoming Maintenance */}
      <div>
        <h3 className="text-sm font-semibold text-gray-900 mb-3">Upcoming Maintenance</h3>
        <div className="space-y-2">
          {data?.upcomingMaintenance?.map((item, index) => (
            <div 
              key={index}
              className="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-center gap-3">
                <Icon name="Tool" className="w-5 h-5 text-gray-600" />
                <div>
                  <p className="text-sm font-medium text-gray-900">{item?.item}</p>
                  <p className="text-xs text-gray-500">Scheduled: {item?.date}</p>
                </div>
              </div>
              <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getPriorityColor(item?.priority)}`}>
                {item?.priority?.toUpperCase()}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OperationalOverview;